module.exports = __webpack_public_path__ + "static/fipcbrownsafari2-cd435730a13aa26295348edb7345e99f.jpeg";